import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0","key":"svg-0"}],["path",{"d":"M6 21v-2a4 4 0 0 1 4 -4h3.5","key":"svg-1"}],["path",{"d":"M17 17v5","key":"svg-2"}],["path",{"d":"M21 17v5","key":"svg-3"}]]

const IconUserPause = createReactComponent('outline', 'user-pause', 'UserPause', __iconNode);

export default IconUserPause;